import { Box, Typography, useMediaQuery, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";

const supportMail =
  "mailto:support@giglgroup.com?subject=Account%20deletion%20request";

export default function AccountDeletion() {
  const isMobile = useMediaQuery("(max-width:800px)");

  return (
    <>
      <Box
        sx={{
          float: isMobile ? "none" : "left",
          maxWidth: "100vw",
          marginLeft: isMobile ? 0 : 6,
          textAlign: "left",
          minHeight: 200,
          pt: 2.5,
        }}
      >
        <Typography
          sx={{
            width: isMobile ? "90%" : "100%",
            maxWidth: 560,
            fontSize: isMobile ? 28 : 40,
            fontWeight: 600,
            mt: 2.5,
          }}
        >
          Account deletion
        </Typography>
        <Typography
          sx={{
            width: isMobile ? "90%" : "100%",
            maxWidth: 560,
            fontSize: isMobile ? 14 : 15,
            mt: isMobile ? 1.25 : 3,
            color: "text.secondary",
          }}
        >
          Last updated: April 2026
        </Typography>
      </Box>

      <Box
        sx={{
          clear: "both",
          width: "100%",
          minHeight: 30,
          mb: 6,
          backgroundColor: "#4158D0",
          backgroundImage:
            "linear-gradient(120deg, #fccb90 0%, #d57eeb 100%)",
        }}
      />

      <Box
        component="main"
        sx={{
          maxWidth: 720,
          margin: isMobile ? "0 auto" : "0 0 0 100px",
          px: isMobile ? 2 : 0,
          pb: 8,
          textAlign: "left",
        }}
      >
        <Typography component="p" sx={{ mb: 3, lineHeight: 1.7 }}>
          This page explains how to request deletion of your Gigl account and
          associated personal data. If you use both a brand account and a creator
          account with the same email, please specify which account you want
          removed (or both).
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          Marketers and brands
        </Typography>
        <Typography component="p" sx={{ mb: 3, lineHeight: 1.7 }}>
          Send an email to{" "}
          <MuiLink href={supportMail}>support@giglgroup.com</MuiLink> from the
          address associated with your Gigl login. Use the subject line
          &quot;Account deletion request&quot; and include the email address of
          the account you want deleted. Our team will confirm your identity and
          process the request. This matches the account-change flow described in
          your dashboard under{" "}
          <Typography component="span" sx={{ fontWeight: 600 }}>
            My Account
          </Typography>
          .
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          Creators
        </Typography>
        <Typography component="p" sx={{ mb: 3, lineHeight: 1.7 }}>
          Email{" "}
          <MuiLink href={supportMail}>support@giglgroup.com</MuiLink> from your
          registered creator email with the subject &quot;Account deletion
          request.&quot; Include your full name and the email on the Gigl
          account so we can locate your profile. If you connected social
          accounts (for example TikTok, YouTube, or Facebook/Instagram),
          mention which platforms were linked so we can revoke access as part of
          closure where applicable.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          What to include
        </Typography>
        <Box component="ul" sx={{ pl: 2.5, mb: 3, lineHeight: 1.8 }}>
          <li>
            <Typography component="span">
              The email address of the Gigl account to delete
            </Typography>
          </li>
          <li>
            <Typography component="span">
              Whether you are a marketer/brand user, a creator, or both
            </Typography>
          </li>
          <li>
            <Typography component="span">
              Any relevant context (duplicate account, company change, etc.)
            </Typography>
          </li>
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          After you request deletion
        </Typography>
        <Typography component="p" sx={{ mb: 3, lineHeight: 1.7 }}>
          We will acknowledge your request and complete deletion or
          anonymization where we no longer need the data to provide the service
          or meet legal obligations. Some information may be retained for a
          limited period where required for fraud prevention, disputes,
          regulatory compliance, or backup systems, consistent with our{" "}
          <MuiLink component={Link} to="/privacypolicy">
            Privacy Policy
          </MuiLink>
          .
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1.5 }}>
          Related policies
        </Typography>
        <Typography component="p" sx={{ lineHeight: 1.7 }}>
          <MuiLink component={Link} to="/privacypolicy">
            Privacy Policy
          </MuiLink>
          {" · "}
          <MuiLink component={Link} to="/terms">
            Terms of Service
          </MuiLink>
        </Typography>
      </Box>
    </>
  );
}
